"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodicSync = void 0;
const exponentialBackoff_1 = require("./exponentialBackoff");
class PeriodicSync {
    constructor(client, name, syncInterval) {
        this.data = new Map();
        this.client = client;
        this.name = name;
        this.startAt = new Date();
        this.startPeriodicSync(syncInterval);
    }
    stop() {
        clearTimeout(this.timeoutID);
    }
    sync() {
        if (this.data.size === 0)
            return;
        this.logInternal(`${this.name} syncing ${this.data.size} items`);
        const startAtWas = this.startAt;
        this.startAt = new Date();
        this.flush(this.prepareData(), startAtWas);
    }
    prepareData() {
        const toShip = new Map(this.data);
        this.data.clear();
        return toShip;
    }
    startPeriodicSync(syncInterval) {
        this.startAt = new Date();
        this.syncInterval = PeriodicSync.calculateSyncInterval(syncInterval);
        this.scheduleNextSync();
    }
    scheduleNextSync() {
        const interval = this.syncInterval();
        this.timeoutID = setTimeout(() => {
            this.sync();
            this.scheduleNextSync(); // Schedule the next sync after the current one completes
        }, interval);
    }
    static calculateSyncInterval(syncInterval) {
        if (syncInterval !== undefined) {
            return () => syncInterval;
        }
        const backoff = new exponentialBackoff_1.ExponentialBackoff(60 * 5, 8);
        return () => backoff.call();
    }
    logInternal(message) {
        const loggerName = `${this.client.clientNameString}.prefab.${this.name}`;
        if (this.client.shouldLog({
            loggerName,
            desiredLevel: "debug",
            defaultLevel: "error",
        }, false // synchronous so that this log ends up in the current batch
        )) {
            // eslint-disable-next-line no-console
            console.log(`${loggerName}: ${message}`);
        }
    }
}
exports.PeriodicSync = PeriodicSync;
